import styled from "styled-components";

export const StyledName = styled.p`
  font-size: 17pt;
  margin-left: 30px;
  margin-bottom: 5px;
  color: rgb(19, 41, 75);;
  font-weight: bold;
`;

export const StyledJobTitle = styled.p`
  font-size: 12pt;
  margin-left: 30px;
  margin-bottom: 5px;
  color: rgb(19, 41, 75);;
`;

export const StyledPhone = styled.p`
  font-size: 9pt;
  margin-left: 30px;
  color: rgb(19, 41, 75);;
`;

export const StyledLink = styled.p`
  font-size: 9pt;
  margin-top: 1pt;
  font-weight: bold;
  a {
    color: blue;
  }
`;
